import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./ProfessionMasterReportSummary.module.css";

const ProfessionMasterReportSummary = ({
  refreshData = () => {},
  refreshRef,
}) => {

  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default ProfessionMasterReportSummary;
